const findValueByKey = (data, key) => {
    if (Array.isArray(data)) {
        for (let item of data) {
            const result = findValueByKey(item, key);
            if (result !== null) {
                return result;
            }
        }
    } else if (typeof data === 'object') {
        for (let k in data) {
            if (k === key) {
                return data[k];
            }
            const result = findValueByKey(data[k], key);
            if (result !== null) {
                return result;
            }
        }
    }
    return null;
};

const tableCellValues =(row,column,structure,allNumberColumn=true)=>{
    if (row[column] && allNumberColumn) {
        return row[column] ;
    }else{
        let cellValue='0'; 
        
        row[structure.riskfactor].forEach((riskFactor)=>{
            if(riskFactor[structure.riskfactor]==column){
                cellValue = riskFactor['sumInsured'];
            }
        })
        return cellValue;
    }
    
      
}

export { findValueByKey,tableCellValues};